<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        大连航运职业技术学校校长姜晓莉一行来我司调研
        <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
      </div>
      <div class="div-text-left news-Regular-14b6">
        <span>2020-04-03</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
      </div>
      <div class="div-line  divcss5">

      </div>
      <div class="div-row div-bottom30">
        <p class="indentation">
          尹勇董事长对姜校长一行的到来表示热烈欢迎，简要介绍了公司的基本情况，并带客人到产品展示厅参观了公司现在最新的产品，希望两家单位在原有基础上继续扩大合作交流，助力各项事业发展取得更大成绩。
          姜晓莉对公司的热情接待表示诚挚的感谢，她表示，大连航运职业技术学校与大连海事大学的尹勇教授团队的合作建立了深厚的感情，海大智龙的产品研发一直处于国内领先水平，希望以此次座谈会为契机，与海大智龙在船员考试培训、科技交流合作等更多方面开展务实合作，真正实现共融、共享、共赢。
        </p>
      </div>
      <img src="static/imgts/news9/1.jpg" />
      <br />
      <img src="static/imgts/news9/2.jpg" />
       <br />
      <img src="static/imgts/news9/3.jpg" />
       <br />
      <img src="static/imgts/news9/4.jpg" />
       <br />
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isflag1: true,
        isflag2: false,
        isflag3: false
      };
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
      handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (parseInt(scrollTop) >= 550 && parseInt(scrollTop) < 1200) {
          // alert(scrollTop)
          this.isflag2 = true;
        }
        if (parseInt(scrollTop) >= 1200) {
          this.isflag3 = true;
        }

      },
      destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
      },
    },
  };

</script>

<style scoped>
img {
  margin-top:30px;
}
  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }



  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }

  .div-padding-left {
    padding-left: 36px;
  }

  .div-top30 {
    margin-top: 30px;
  }

  .div-top0 {
    margin-bottom: 0px !important;
  }


  img {
    vertical-align: middle;
    border-style: none;
    width: 100%; 
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2020/news9.vue